export interface IAssessmentInfo {
  apiRoute: string;
  title: string;
  route: string;
  assessmentType: string;
  documentType: string;
  displayTitle?: string;
  displayTitlePreschool?: string;
  evaluationID?: number;
}

export const ASSESSMENT_INFO: Record<string, IAssessmentInfo> = {
  capdAssessment: {
    apiRoute: 'CapdAssessment',
    assessmentType: 'CapdAssessment',
    title: 'Central Auditory Processing Disorder Assessment',
    displayTitle: 'Central Auditory Processing Disorder Assessment',
    route: 'capd-assessment',
    documentType: '21',
    evaluationID: 44
  },
  customObservationAssessment: {
    apiRoute: 'CustomObservationAssessment',
    assessmentType: 'CustomObservationAssessment',
    title: 'Custom Observation Assessment',
    displayTitle: 'Custom Observation Assessment',
    route: 'custom-observation-assessment',
    documentType: '22',
  },
  feedingAssessment: {
    apiRoute: 'FeedingAssessment',
    assessmentType: 'FeedingAssessment',
    title: 'Feeding Assessment',
    displayTitle: 'Feeding Assessment',
    route: 'feeding-assessment',
    documentType: '23',
    evaluationID: 45
  },
  classroomObservation: {
    apiRoute: 'ClassroomObservation',
    assessmentType: 'ClassroomObservation',
    title: 'Classroom Observation',
      displayTitle: 'Classroom Observation',
    route: 'classroom-observation',
    documentType: '24',
    evaluationID: 7
  },
  observation: {
    apiRoute: 'ClassroomObservation',
    assessmentType: 'Observations',
    title: 'Observations',
    displayTitle: 'Observations',
    route: 'classroom-observation',
    documentType: '24',
    evaluationID: 22
  },
  speechAndLanguageAssessment: {
    apiRoute: 'SpeechAndLanguageAssessment',
    assessmentType: 'SpeechAndLanguageAssessment',
    title: 'Speech and Language Assessment',
    displayTitle: 'Speech and Language Assessment',
    route: 'speech-language-assessment',
    documentType: '25',
    evaluationID: 36
  },
  hearingScreeningAssessment: {
    apiRoute: 'HearingScreeningAssessment',
    assessmentType: 'HearingScreening',
    title: 'Hearing Screening Assessment',
    displayTitle: 'Hearing Screening Assessment',
    route: 'hearing-screening-assessment',
    documentType: '26',
    evaluationID: 13
  },
  orientationAndMobilityAssessment: {
    apiRoute: 'OrientationAndMobilityAssessment',
    assessmentType: 'OrientationAndMobilityAssessment',
    title: 'Orientation and Mobility Assessment',
    displayTitle: 'Orientation and Mobility Assessment',
    route: 'orientation-mobility-assessment',
    documentType: '27',
    evaluationID: 46
  },
  visionScreeningAssessment: {
    apiRoute: 'VisionScreeningAssessment',
    assessmentType: 'VisionScreeningAssessment',
    title: 'Functional Vision Assessment',
    displayTitle: 'Functional Vision Assessment',
    route: 'functional-vision-assessment',
    documentType: '28',
    evaluationID: 42
  },
  genericAssessment: {
    apiRoute: 'GenericAssessment',
    assessmentType: 'GenericAssessment',
    title: 'Generic (for all other assessments)',
    displayTitle: '{Assessment - Generic - Type}',
    route: 'generic-assessment',
    documentType: '29',
  },
  psychologicalAssessment: {
    apiRoute: 'PsychologicalAssessment',
    assessmentType: 'PsychologicalAssessment',
    title: 'Psychological Assessment',
    displayTitle: 'Psychological Assessment',
    displayTitlePreschool: 'Preschool Psychological Assessment',
    route: 'psychological-assessment',
    documentType: '30',
    evaluationID: 32
  },
  psychologicalUpdate: {
    apiRoute: 'PsychologicalUpdate',
    assessmentType: 'PsychologicalUpdate',
    title: 'Psychological Update',
    displayTitle: 'Psychological Update',
    route: 'psychological-update',
    documentType: '31',
    evaluationID: 33
  },
  psychologicalEvaluation: {
    apiRoute: 'PsychologicalEvaluation',
    assessmentType: 'Psychological Evaluation',
    title: 'Psychological Evaluation Assessment',
    displayTitle: 'Psychological Evaluation',
    route: 'psychological-evaluation',
    documentType: '32',
  },
  psychoeducationalAssessment: {
    apiRoute: 'PsychoeducationalAssessment',
    assessmentType: 'Psychoeducational Assessment',
    title: 'Psychoeducational Assessment',
    displayTitle: 'Psychoeducational Assessment',
    displayTitlePreschool: 'Preschool Psychoeducational Assessment',
    route: 'psychoeducational-assessment',
    documentType: '33',
    evaluationID: 31
  },
  prepsychoeducationalAssessment: {
    apiRoute: 'PrePsychoeducationalAssessment',
    assessmentType: 'PrePsychoeducational Assessment',
    title: 'Psychoeducational Assessmentt',
    displayTitle: 'Psychoeducational Assessment',
    route: 'prepsychoeducational-assessment',
    documentType: '34',
  },

  adaptedPhysicalEducationAssessment: {
    apiRoute: 'AdaptedPhysicalEducationAssessment',
    assessmentType: 'Adapted Physical Education assessment',
    title: 'Adapted Physical Education Assessment',
    displayTitle: 'Adapted Physical Education Assessment',
    route: 'adapted-physical-education-assessment',
    documentType: '35',
    evaluationID: 1
  },
  assistiveTechnologyAssessment: {
    apiRoute: 'AssistiveTechnologyAssessment',
    assessmentType: 'Assistive Technology Assessment',
    title: 'Assistive Technology Assessment',
    displayTitle: 'Assistive Technology Assessment',
    route: 'assistive-technology-assessment',
    documentType: '36',
    evaluationID: 3
  },
  occupationalTherapyAssessment: {
    apiRoute: 'OccupationalTherapyAssessment',
    assessmentType: 'Occupational Therapy Assessment',
    title: 'Occupational Therapy Assessment',
    displayTitle: 'Occupational Therapy Assessment',
    route: 'occupational-therapy-assessment',
    documentType: '37',
    evaluationID: 23
  },
  educationalEvaluation: {
    apiRoute: 'educationalEvaluationReport',
    assessmentType: 'Educational Evaluation Report',
    title: 'Educational Evaluation Report',
      displayTitle: 'Educational Evaluation Report',
    route: 'educational-evaluation-report',
    documentType: '38',
    evaluationID: 10
  },
  functionalBehaviorAssessment: {
    apiRoute: 'functionalBehaviorAssessment',
    assessmentType: 'Functional Behavior Assessment (FBA)',
    title: 'Functional Behavior Assessment (FBA)',
      displayTitle: 'Functional Behavior Assessment (FBA)',
    route: 'functional-behavior-assessment',
    documentType: '39',
    evaluationID: 11
  },
  vocationalTeacherAssessment: {
    apiRoute: 'vocationalTeacherAssessment',
    assessmentType: 'Level 1 Vocational Interview - Teacher Assessment',
    title: 'Level 1 Vocational Interview - Teacher Assessment',
    displayTitle: 'Level 1 Vocational Interview - Teacher',
    route: 'vocational-teacher-assessment',
    documentType: '40',
    evaluationID: 16
  },
  vocationalParentAssessment: {
    apiRoute: 'vocationalParentAssessment',
    assessmentType: 'Level 1 Vocational Interview - Parent/Guardian',
    title: 'Level 1 Vocational Interview - Parent/Guardian',
    displayTitle: 'Level 1 Vocational Interview - Parent/Guardian',
    route: 'vocational-parent-assessment',
    documentType: '41',
    evaluationID: 17
  },
  vocationalStudentAssessment: {
    apiRoute: 'vocationalStudentAssessment',
    assessmentType: 'Level 1 Vocational Interview - Student',
    title: 'Level 1 Vocational Interview - Student',
    displayTitle: 'Level 1 Vocational Interview - Student',
    route: 'vocational-student-assessment',
    documentType: '42',
    evaluationID: 18
  },
  physicalTherapyAssessment: {
    apiRoute: 'PhysicalTherapyAssessment',
    assessmentType: 'Physical Therapy Assessment',
    title: 'Physical Therapy Assessment',
    displayTitle: 'Physical Therapy Assessment',
    displayTitlePreschool: 'Preschool Physical Therapy Assessment',
    route: 'physical-therapy-assessment',
    documentType: '43',
    evaluationID: 27
  },
  physicalTherapyTeacherAssessment: {
    apiRoute: 'PhysicalTherapyTeacherAssessment',
    assessmentType: 'Physical Therapy Teacher Assessment',
    title: 'Physical Therapy Teacher Checklist',
    displayTitle: 'Physical Therapy Teacher Checklist',
    route: 'physical-therapy-teacher-checklist',
    documentType: '44',
    evaluationID: 54
  },
  physicalTherapyParentAssessment: {
    apiRoute: 'PhysicalTherapyParentAssessment',
    assessmentType: 'Physical Therapy Parent Assessment',
    route: 'physical-therapy-parent-checklist',
    title: 'Physical Therapy Parent Checklist',
    displayTitle: 'Physical Therapy Parent Checklist',
    documentType: '45',
    evaluationID: 53
  },
  physicalExamination: {
    apiRoute: 'PhysicalExamination',
    assessmentType: 'Physical Examination',
    route: 'physical-examination',
    title: 'Physical Examination',
    displayTitle: 'Physical Examination',
    documentType: '95',
    evaluationID: 50
  },
  occupationalTherapyTeacherAssessment: {
    apiRoute: 'OccupationalTherapyTeacherAssessment',
    assessmentType: 'Occupational Therapy Teacher Assessment',
    title: 'Occupational Therapy Teacher Checklist',
    displayTitle: 'Occupational Therapy Teacher Checklist',
    route: 'occupational-therapy-teacher-checklist',
    documentType: '46',
    evaluationID: 52
  },
  occupationalTherapyParentChecklist: {
    apiRoute: 'occupationalTherapyParentChecklist',
    assessmentType: 'Occupational Therapy Parent Assessment',
    title: 'Occupational Therapy Parent Checklist',
    displayTitle: 'Occupational Therapy Parent Checklist',
    route: 'occupational-therapy-parent-checklist',
    documentType: '47',
    evaluationID: 51
  },
  socialHistoryUpdate: {
    apiRoute: 'socialHistoryUpdate',
    assessmentType: 'Social History Update',
    title: 'Social History Update',
    displayTitle: 'Social History Update',
    route: 'social-history-update',
    documentType: '49',
    evaluationID: 49
  },
  socialHistoryEval: {
    apiRoute: 'socialHistoryEval',
    assessmentType: 'Social History Evaluation',
    title: 'Social History Evaluation',
    displayTitle: 'Social History Evaluation',
    route: 'social-history-eval',
    documentType: '48',
    evaluationID: 35
  },
  GenericAssessment: {
    apiRoute: 'GenericAssessment',
    assessmentType: 'Generic Assessment',
    title: 'Generic Assessment',
    displayTitle: 'Generic',
    route: 'generic-assessment',
    documentType: '29',
  },
  audiologicalAssessment: {
    apiRoute: 'AudiologicalAssessment',
    assessmentType: 'Audiological Assessment',
    title: 'Audiological Assessment',
    displayTitle: 'Audiological Assessment',
    route: 'audiological-assessment',
    documentType: '50',
    evaluationID: 5
  },
  assistiveTechnologyEvaluationDistrict75: {
    apiRoute: 'AssistiveTechnologyEvaluationDistrict75',
    assessmentType: 'Assistive Technology for District 75 Assessment',
    title: 'Assistive Technology for District 75 Assessment',
    displayTitle: 'Assistive Technology for District 75 Assessment',
    route: 'assistive-technology-evaluation-district-75',
    documentType: '51',
    evaluationID: 4
  },
  psychiatricAssessment: {
    apiRoute: 'PsychiatricAssessment',
    assessmentType: 'Psychiatric Assessment',
    title: 'Psychiatric Assessment',
    displayTitle: 'Psychiatric Assessment',
    route: 'psychiatric-assessment',
    documentType: '52',
    evaluationID: 29
  },
  neuropsychologicalAssessment: {
    apiRoute: 'NeuropsychologicalAssessment',
    assessmentType: 'Neuropsychological Assessment',
    title: 'Neuropsychological Assessment',
      displayTitle: 'Neuropsychological Assessment',
    route: 'neuropsychological-assessment',
    documentType: '53',
    evaluationID: 47
  },
  neurologicalAssessment: {
    apiRoute: 'NeurologicalAssessment',
    assessmentType: 'Neurological Assessment',
    title: 'Neurological Assessment',
      displayTitle: 'Neurological Assessment',
    route: 'neurological-assessment',
    documentType: '54',
    evaluationID: 21
  },
  other: {
    apiRoute: 'Other',
    assessmentType: 'Other',
    title: 'Other',
    displayTitle: 'Other',
    route: 'other-assessment',
    documentType: '55',
  },
};
